import { S, TH, TD, EmptyState, formatDate } from '../regureStyles';
import { STATUS_MAP } from './Filters';

const Table = ({ filtered, loading, handleGenerate, generating, handleSubmit }) => {
  return (
    <div style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 10, overflow: 'hidden' }}>
      {loading ? (
        <>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 60 }}>
            <div style={{ width: 36, height: 36, border: '3px solid #e2e8f0', borderTopColor: '#7c3aed', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
          </div>
        </>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: S.bgCard }}>
              <TH>Report ID</TH>
              <TH>Report Name</TH>
              <TH>Category</TH>
              <TH>Period</TH>
              <TH>Due Date</TH>
              <TH>Submitted</TH>
              <TH>Status</TH>
              <TH></TH>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={8}>
                  <EmptyState icon='file-text' title='No reports found' description='Try adjusting your search or filters, or create a new report.' />
                </td>
              </tr>
            ) : (
              filtered.map((r, i) => {
                const s = STATUS_MAP[r.status] || STATUS_MAP.draft;
                return (
                  <tr
                    key={r._id}
                    style={{ borderTop: `1px solid ${S.borderLight}`, background: i % 2 === 0 ? '#fff' : S.bgCard }}
                    onMouseEnter={e => (e.currentTarget.style.background = S.bgHover)}
                    onMouseLeave={e => (e.currentTarget.style.background = i % 2 === 0 ? '#fff' : S.bgCard)}
                  >
                    <TD>
                      <span style={{ fontFamily: 'monospace', fontSize: 12, color: S.textMuted }}>{r.reportId}</span>
                    </TD>
                    <TD>
                      <span style={{ fontWeight: 500, color: S.textPrimary }}>{r.name}</span>
                    </TD>
                    <TD>
                      <span style={{ fontSize: 12, padding: '3px 8px', background: `${S.info}15`, color: S.info, borderRadius: 4, fontWeight: 500 }}>{r.category}</span>
                    </TD>
                    <TD>{r.period || '—'}</TD>
                    <TD>{formatDate(r.dueDate)}</TD>
                    <TD>{r.submittedDate ? formatDate(r.submittedDate) : <span style={{ color: S.textMuted }}>—</span>}</TD>
                    <TD>
                      <span
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 5,
                          padding: '3px 10px',
                          background: s.bg,
                          color: s.color,
                          borderRadius: 20,
                          fontSize: 12,
                          fontWeight: 500,
                        }}
                      >
                        {s.label}
                      </span>
                    </TD>
                    <TD>
                      <div style={{ display: 'flex', gap: 6 }}>
                        {r.status !== 'submitted' && (
                          <button
                            onClick={() => handleGenerate(r)}
                            disabled={generating === r._id}
                            style={{
                              padding: '5px 10px',
                              border: `1px solid ${S.borderLight}`,
                              borderRadius: 6,
                              background: '#fff',
                              fontSize: 11,
                              cursor: 'pointer',
                              color: S.textSecondary,
                            }}
                          >
                            {generating === r._id ? '...' : 'Generate'}
                          </button>
                        )}
                        {(r.status === 'review' || r.status === 'draft') && (
                          <button
                            onClick={() => handleSubmit(r)}
                            style={{
                              padding: '5px 10px',
                              border: `1px solid ${S.success}40`,
                              borderRadius: 6,
                              background: `${S.success}08`,
                              fontSize: 11,
                              cursor: 'pointer',
                              color: S.success,
                              fontWeight: 600,
                            }}
                          >
                            Submit
                          </button>
                        )}
                        <button
                          style={{
                            padding: '5px 12px',
                            border: `1px solid ${S.borderLight}`,
                            borderRadius: 6,
                            background: '#fff',
                            fontSize: 12,
                            cursor: 'pointer',
                            color: S.textSecondary,
                          }}
                        >
                          View
                        </button>
                      </div>
                    </TD>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Table;
